// tabs section component

import * as $ from "jquery";

export default class ContainerFeaturesExpand {
  domRoot: JQuery<any>;
  params: any;
  container: JQuery<HTMLElement>;
  trigger: JQuery<HTMLElement>;
  activeClass: string;

  constructor(domRoot: HTMLElement, params: any) {
    this.domRoot = $(domRoot);
    this.params = { ...params };

    this.container = $(".imkt-container-features-expand", this.domRoot);
    this.trigger = $(
      ".imkt-container-features-expand__trigger--wrapper",
      this.domRoot
    );
    this.activeClass = "active";

    this.init();
  }

  init() {
    this.bindEvents();
  }

  bindEvents() {
    var self = this;
    this.domRoot.on("click", this.trigger, function () {
      $(this).toggleClass(self.activeClass);
    });
  }
}
